import { ElementType, IElement } from '../../../models/Element';

// Only these keys are read by the API blade template
// (resources/views/livewire/elements/form/form-company-change.blade.php);
// all other form fields and labels are hardcoded server-side.
export type FormCompanyChange = IElement & {
  title: string;

  heading_primary: string;

  success_message?: string;
};

export const defaultFormCompanyChange: FormCompanyChange = {
  id: 0,
  name: ElementType.FORM_COMPANY_CHANGE,

  title: 'Wijziging doorgeven',

  heading_primary: 'Jouw gegevens',
};
